// extracted by mini-css-extract-plugin
export default {"navbar":"NavbarSimple_navbar__QAkfB","footer":"NavbarSimple_footer__CmLl+","link":"NavbarSimple_link__LkS+h","linkIcon":"NavbarSimple_linkIcon__Ogx42"};